
import { Component, Mixins, Prop } from 'vue-property-decorator'

import StateMixin from '@/mixins/state'

@Component({})
export default class AppNavItem extends Mixins(StateMixin) {
  @Prop({ type: String })
  public title!: string

  @Prop({ type: String })
  public to!: string

  @Prop({ type: Boolean, default: false })
  public exact!: boolean

  @Prop({ type: String })
  public icon!: string

  get isMobile () {
    return this.$vuetify.breakpoint.mobile
  }
}

